import service from "./service";
export const getVehicles = () => {
    return service({
        url: `/vehicle`,
        method: 'GET',
    });
};
